// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/adf-ndb-terms.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/adf-ndb-terms/adf-ndb-terms.js';

mount([g0]);
